export const AMEND_APPOINTMENT_MODAL_TITLE = 'Are you sure you want to quit editing?';
export const AMEND_APPOINTMENT_MODAL_MESSAGE = 'If you close now any changes you’ve made won’t be saved.';

export const ANALYTICS_APPT_MODAL = 'amend appt confirmation model';
export const ANALYTICS_APPT_KEEP_EDITING = 'amend appt confirmation:Keep editing';
export const ANALYTICS_APPT_QUIT = 'amend appt confirmation:Quit';

export const KEEP_EDITING_LABEL = 'Keep editing';
export const QUIT_LABEL = 'Quit';
export const MEDALLIA_AMMEND_FORM_ID = '5841';